import { Theme, css } from '@emotion/react';

export const container = css`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: flex-end;
  user-select: none;
`;

export const overflowIndicator = ({ spacing }: Theme) => css`
  padding-left: ${spacing(1)}px;
`;
